"use strict";

angular.module("vendor")
.controller("CatalogEntryDiscountModalController", function(
    $scope, $attrs, $filter, close, FormError, PatternService, DiscountCalculatorFactory, DiscountService,
    moment
) {
    var _this = this;
    var price = $attrs.price;
    $scope.now = moment();

    this.discount = $attrs.discount;
    this.discountExists = !!this.discount;
    if (!this.discount) {
        this.discount = {enabled: true};
    }

    this.pattern = PatternService;
    this.discountResult = {};

    $scope.discountDiscountTypes = DiscountService.queryDiscountTypes();

    var unregisterWatcher = $scope.$watch(function() {
        return _this.discount;
    }, function() {
        if (_this.discount && _this.discount.enabled) {
            var discount = new DiscountCalculatorFactory(_this.discount.discount_type, _this.discount.discount_value);
            _this.discountResult = discount.getCatalogEntryResult(price);
        }
    }, true);

    this.getSymbolFromTypeSelected = function() {
        if ($scope.discountDiscountTypes && this.discount && this.discount.discount_type) {
            var element = $filter("filter")($scope.discountDiscountTypes, {key: this.discount.discount_type}, true);
            if (element.length) {
                return element[0]["symbol"];
            }
        }
    };

    this.delete = function() {
        DiscountService.delete(_this.discount).$promise.then(
            function() {
                _this.close();
                close.apply(_this, [{deleted: true}]);
            }
        );
    };

    this.close = function() {
        unregisterWatcher();
        $scope.$element.modal("hide");
        $scope.$element.remove();
    };

    this.save = function() {
        $scope.discountForm.$setSubmitted();
        FormError.focus("discountForm");

        if ($scope.discountForm.$valid) {
            this.close();
            close.apply(this, [{
                discount: this.discount
            }]);
        }
    };

});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-entry-tab/catalog-entry-discount/catalog-entry-discount.modal.js
// module id = 900
// module chunks = 0